import { default as i18nextInstance } from 'i18next';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { DEFAULT_LOCALE } from './locales';

/**
 * Runtime i18n: the dictionary is `public/i18n/pt-BR.json`, loaded on demand — it is not
 * part of the bundle.
 */
export async function initI18n() {
  await i18nextInstance
    .use(HttpBackend)
    .use(initReactI18next)
    .init({
      lng: DEFAULT_LOCALE,
      fallbackLng: DEFAULT_LOCALE,
      supportedLngs: [DEFAULT_LOCALE],
      defaultNS: 'translation',
      backend: { loadPath: '/i18n/{{lng}}.json' },
      // React already escapes what it renders.
      interpolation: { escapeValue: false },
      returnNull: false,
    });
  document.documentElement.lang = DEFAULT_LOCALE;
  return i18nextInstance;
}

/**
 * The same dictionary, bundled in instead of fetched: an embedding host has no `/i18n/` to serve
 * it from, and its document's language is its own. Once per page (later mounts reuse it).
 */
export async function initBundledI18n(dictionary: Record<string, unknown>) {
  if (i18nextInstance.isInitialized) return i18nextInstance;
  await i18nextInstance.use(initReactI18next).init({
    lng: DEFAULT_LOCALE,
    fallbackLng: DEFAULT_LOCALE,
    supportedLngs: [DEFAULT_LOCALE],
    defaultNS: 'translation',
    resources: { [DEFAULT_LOCALE]: { translation: dictionary } },
    interpolation: { escapeValue: false },
    returnNull: false,
  });
  return i18nextInstance;
}

export { i18nextInstance as i18next };
